<template>
  <span>
    <router-view/>
  </span>
</template>

<script>
export default {
  name: 'AppBlankMain',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  },
  methods: {
  },
}
</script>

<style scoped>
.app-main {
  min-height: calc(100vh - 100px);
  position: absolute;
  overflow: auto;
  top: 100px;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 15px;
  /*min-height: auto;*/

}
.app-main.ishiddens{
  overflow-x: hidden;
}
</style>
